import React, { useEffect, useState } from "react";
import { axiosInstance } from "common/network";
import {
  Box,
  Stack,
  Modal,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import { formatDate } from "helpers/formaters";
import { PRIMARY_COLOR_HEX } from "theme/palette";
import moment from "moment";

const UpdateExpireDateModal = (props) => {
  const { accountUuid, packageUuid } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    props.handleClose();
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  const handleConfirm = () => {
    const body = {
      package_uuid: packageUuid,
      expiry_date: moment(new Date(props?.selectedDate)).format("YYYY-MM-DD"),
    };

    const url =
      process.env.REACT_APP_API_ROOT + `v3/accounts/${accountUuid}/packages`;

    try {
      axiosInstance
        .put(url, body)
        .then((response) => {
          console.log("update expiration date success: ", response);
          props.handleSuccess();
          handleClose();
        })
        .catch((e) => {
          console.log("update expiration date error:", e);
          handleClose();
        });
    } catch (err) {
      console.log("update expiration date error:", err);
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="update-expiry-title"
      aria-describedby="update-expiry-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: 420,
          bgcolor: "background.paper",
          borderRadius: 1,
          boxShadow: 24,
          overflow: "hidden",
        }}
      >
        <Box sx={{ px: 3, pt: 2.5, pb: 1.5 }}>
          <Typography
            id="update-expiry-title"
            variant="h6"
            sx={{ fontWeight: 600 }}
          >
            Update expiry date
          </Typography>
        </Box>
        <Divider sx={{ borderBottomWidth: 3, borderColor: PRIMARY_COLOR_HEX }} />

        <Box sx={{ px: 3, py: 2.5 }}>
          <Typography id="update-expiry-description" variant="body2">
            This action will update the expiry date to{" "}
            <strong>{formatDate(props?.selectedDate)}</strong>. Are you sure you
            want to continue?
          </Typography>
        </Box>

        <Divider />
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={1.5}
          sx={{ px: 3, py: 2 }}
        >
          <Button onClick={handleClose} sx={{ color: PRIMARY_COLOR_HEX }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={handleConfirm}
            sx={{
              bgcolor: PRIMARY_COLOR_HEX,
              color: "#fff",
              "&:hover": { bgcolor: PRIMARY_COLOR_HEX },
            }}
          >
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default UpdateExpireDateModal;
